<!--
   Created by qing on 2022/6/8 下午9:26
   Des:
-->
<template>
	<div
		class="work-page"
		v-wechat-title="title"
	>

		<div class="custom-header">
			<div class="container">
				<div
					class="user-info"
					v-if="$store.state.userInfo"
				>
					<van-image
						width="60px"
						height="60px"
						fit="cover"
						radius="50%"
						:src="$store.state.userInfo.headImg"
					>
					</van-image>
					<div>
						<span class="user-name">{{$store.state.userInfo.userName}}</span>
						{{actionFetchCurrentDateRange()}}好

						<div class="company-text">
							{{ $store.getters.company ? $store.getters.company.companyName : '' }}
						</div>
					</div>
				</div>
				<div
					class="right-container"
					@click="onClickSelect"
					v-if="actions && actions.length > 1"
				>
					<template v-if="false">
						{{selectName}}
						<van-icon name="arrow-down" />
					</template>
					<svg
						width="20"
						height="20"
						viewBox="0 0 48 48"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect
							width="48"
							height="48"
							fill="white"
							fill-opacity="0.01"
						/>
						<path
							d="M42 19H5.99998"
							stroke="#333"
							stroke-width="4"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M30 7L42 19"
							stroke="#333"
							stroke-width="4"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M6.79897 29H42.799"
							stroke="#333"
							stroke-width="4"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M6.79895 29L18.799 41"
							stroke="#333"
							stroke-width="4"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				</div>
			</div>
			<div class="header-bg">
			</div>
		</div>

		<HomeConfigView
			v-if="!loading"
			:key="selectCustom"
			:custom-id="selectCustom"
		></HomeConfigView>

		<van-action-sheet
			v-model="show"
			get-container="body"
			close-on-click-overlay
			@select="selectCustomChange"
			:actions="actions"
		>
		</van-action-sheet>
	</div>
</template>

<script>
	import HomeConfigView from "../../RyHomeConfig/redact/View"
	import {
		fetchCurrentDateRange
	} from "../../../assets/js/Untis";
	export default {
		name: "workStation",
		data() {
			return {
				loading: false,
				aEle: null,
				selectCustom: '',
				// 个人自定义首页
				userPageInfo: null,
				customList: [],
				show: false,
				title: ''
			}
		},
		components: {
			HomeConfigView
		},
		computed: {
			actions() {
				return this.customList.map(item => {
					return {
						name: item.pageName,
						id: item.customId
					}
				})
			},
			selectName() {
				const select = this.customList.filter(item => item.customId === this.selectCustom)[0]
				if (select) {
					return select.pageName
				}
				return ''
			}
		},
		created() {

			if (this.$route.params.pageConfigId) {
				this.$store.dispatch('actionSpacePageConfigDetail', {
					spaceId: this.$route.params.spaceId,
					pageConfigId: this.$route.params.pageConfigId
				}).then(res => {
					this.title = res.pageTitle
					this.$store.dispatch('setPageTitle', this.title)
				}).catch(console.error)
			} else {
				this.title = '工作台'
				this.$store.dispatch('setPageTitle', this.title)
			}

			this.loading = true
			this.$store.dispatch('actionCustomHomeUserMatch')
				.then(res => {

					console.log('actionCustomHomeUserMatch', res)
					this.userPageInfo = res.userPageInfo[0]
					const customOpts = [...res.userPageInfo, ...res.matchPageList]
					if (!customOpts.length) {
						customOpts.push({
							pageName: '系统默认工作台',
							customId: 'default'
						})
					}

					this.customList = customOpts

					const homePageStr = localStorage.getItem('home-page')
					const key = `${this.$store.getters.userId}_${this.$store.getters.currentCompanyId}`
					let homePageConfig = {}

					if (homePageStr) {
						homePageConfig = JSON.parse(homePageStr)
						const cacheCustomId = homePageConfig[key]

						if (cacheCustomId && customOpts.map(item => item.customId).includes(cacheCustomId)) {
							this.selectCustom = cacheCustomId
						} else {
							this.$toast.success(`已经切换为${customOpts[0].pageName}`)
							this.selectCustom = customOpts[0] ? customOpts[0].customId : ''
							homePageConfig[key] = this.selectCustom
						}

					} else {
						this.selectCustom = customOpts[0] ? customOpts[0].customId : ''
						homePageConfig[key] = this.selectCustom
					}

					localStorage.setItem('home-page', JSON.stringify(homePageConfig))

				}).catch(console.error)
				.finally(() => {
					this.loading = false
				})
		},
		methods: {

			actionFetchCurrentDateRange() {
				return fetchCurrentDateRange()
			},
			selectCustomChange(val) {
				console.log('selectCustomChange', val, this.customList)
				const select = this.customList.filter(item => item.pageName === val.name)[0]
				if (select) {
					this.selectCustom = select.customId

					const homePageStr = localStorage.getItem('home-page')
					const key = `${this.$store.getters.userId}_${this.$store.getters.currentCompanyId}`
					let homePageConfig = {}
					if (homePageStr) {
						homePageConfig = JSON.parse(homePageStr)
					}
					homePageConfig[key] = this.selectCustom
					localStorage.setItem('home-page', JSON.stringify(homePageConfig))
				}
				this.show = false
			},
			onClickSelect() {
				this.show = true
			}
		},
	}
</script>

<style lang="less">
	.work-page {
		height: 100%;
		overflow: auto;
		box-sizing: border-box;
		-webkit-overflow-scrolling: touch;


		.custom-header {
			height: 100px;
			width: 100%;
			position: relative;

			.header-bg {
				position: absolute;
				top: 0;
				right: 0;
				left: 0;
				height: 60px;
				border-bottom-left-radius: 30px;
				border-bottom-right-radius: 30px;
				background-color: #4260FA;
				opacity: 0.7;
				z-index: 1;
			}

			.container {
				background-color: #ffffff;
				border-radius: 5px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 10px;
				position: absolute;
				top: 20px;
				right: 10px;
				left: 10px;
				height: 80px;
				z-index: 2;
			}

			.user-info {
				color: #5d616f;
				font-size: 14px;
				display: flex;
				align-items: center;

				.van-image {
					margin-right: 15px;
				}

				.user-name {
					color: #2D8cF0;
					font-size: 16px;
					font-weight: 600;
				}

				.company-text {
					margin-top: 10px;
					line-height: 20px;
					font-size: 14px;
					color: #2b3441;
				}
			}

			.right-container {
				display: flex;
				align-items: center;
				font-size: 12px;
				padding: 10px 0;
				/*border-radius: 4px;*/
				/*border: 1px solid #e6e6e6;*/

				i {
					margin-left: 5px;
				}
			}

		}

	}
</style>
